import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {
  ApiController,
  ApiExecutor,
  ApiResponse,
  ApiValidationService,
  Body,
  DELETE,
  GET,
  POST,
  PUT,
  Params,
  PaginatedResult,
  Query,
} from '@app/core/api';

import {SaveUserTemplateDto} from './dto';
import type {UserTemplateResult} from './user-template-api.models';

@ApiController('api/app/user-template')
@Injectable({
  providedIn: 'root',
})
export class UserTemplateApiService {
  constructor(
    public apiExecutor: ApiExecutor,
    public apiValidationService: ApiValidationService,
  ) {}

  @GET('')
  getUserTemplates(@Query() query: Record<string, unknown>): Observable<ApiResponse<PaginatedResult<UserTemplateResult>>> {
    return {} as Observable<ApiResponse<PaginatedResult<UserTemplateResult>>>;
  }

  @GET('/:templateId')
  getUserTemplate(@Params('templateId') templateId: number): Observable<ApiResponse<UserTemplateResult>> {
    return {} as Observable<ApiResponse<UserTemplateResult>>;
  }

  @POST('')
  createUserTemplate(@Body() dto: SaveUserTemplateDto): Observable<ApiResponse<number>> {
    return {} as Observable<ApiResponse<number>>;
  }

  @PUT('/:templateId')
  updateUserTemplate(
    @Params('templateId') templateId: number,
    @Body() dto: SaveUserTemplateDto,
  ): Observable<ApiResponse<boolean>> {
    return {} as Observable<ApiResponse<boolean>>;
  }

  @DELETE('/:templateId')
  deleteUserTemplate(@Params('templateId') templateId: number): Observable<ApiResponse<boolean>> {
    return {} as Observable<ApiResponse<boolean>>;
  }
}
